import styled from "styled-components"

export const ContainerWrapper = styled.div`
    
    display: block;

`
